































































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useGlobals } from '@/hooks/use-globals';
import { getViewStorePath } from '@/store/store.helpers';
import { name } from '@/views/rate-checker-configuration/rate-checker/rate-checker.route';
import CSelect from '@/components/form/select/select.component.vue';
import cBreadcrumb from '@/components/breadcrumb/breadcrumb.component.vue';
import COption from '@/components/form/option/option.component.vue';
import CFilterTitle from '@/components/filter-panel/components/filter-title/filter-title.component.vue';
import CFooterPanel from '@/components/footer-panel/footer-panel.component.vue';
import CTag from '@/components/tag/tag.component.vue';
import { TranslateResult } from 'vue-i18n';
import CCloseIcon from '@/components/icons/icon-close.component.vue';

export default defineComponent({
  name: 'vRateChecker',
  components: {
    CCloseIcon,
    CTag,
    CFilterTitle,
    COption,
    CSelect,
    cBreadcrumb,
    CFooterPanel,
  },
  setup() {
    const { i18n, store } = useGlobals();
    const getBreadcrumbTranslation = computed((): TranslateResult => i18n.t(`${name}.meta.breadcrumb`));
    const brandDataSource = computed((): string => store.state.views.vRateChecker.brandDataSource);
    const options = computed((): Array<string> => store.state.views.vRateChecker.dataSource);
    const sources = computed((): Array<string> => store.state.views.vRateChecker.sources);
    const orderListOfSources = computed((): Array<string> => store.state.views.vRateChecker.orderListOfSources);
    const getTranslation = (value: string): string => ref(i18n.t(`${name}.${value}`)).value.toString();

    const setBrandDataSource = (event: string) => {
      store.commit('views/vRateChecker/setBrandDataSource', event);
    };

    const removeTag = (option: string) => {
      store.commit('views/vRateChecker/setSource', option);
    };

    const saveConfiguration = () => {
      store.dispatch('views/vRateChecker/saveRateCheckerConfiguration');
    };
    const setSource = (element: string) => {
      store.commit('views/vRateChecker/setSource', element);
    };

    store.dispatch(`${getViewStorePath(name)}/checkRateChecker`);
    store.dispatch(`${getViewStorePath(name)}/rateCheckerConfiguration`);
    store.dispatch(`${getViewStorePath(name)}/getDataSource`);
    return {
      options,
      sources,
      setSource,
      removeTag,
      getTranslation,
      brandDataSource,
      saveConfiguration,
      setBrandDataSource,
      orderListOfSources,
      getBreadcrumbTranslation,
    };
  },
});
